export default "__VITE_ASSET__DdfDRRV4__"